<template>
    <header class="header" :class="classes">
        <div class="g_restrict">
            <logo-nespresso />
            <selector-language />
        </div>
    </header>
</template>

<script>
import LogoNespresso from '@/components/common/LogoNespresso'
import SelectorLanguage from '@/components/common/SelectorLanguage'

export default {
    name: 'LayoutHeader',
    components: {
        LogoNespresso,
        SelectorLanguage
    },
    data() {
        return {
            sticky: false
        }
    },
    computed: {
        classes() {
            return { sticky: this.sticky }
        }
    },
    mounted() {
        this.$emit('ui', { height: this.$el.offsetHeight })
        this.watchScroll()
    },
    methods: {
        updateUi(header) {
            this.header = header
        },
        watchScroll() {
            document.addEventListener('scroll', () => {
                this.sticky = window.scrollY > 80
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import ~gvue/src/core/Zone/sass/zone/zone
.header
    position: fixed
    z-index: 1
    top: 0
    right: 0
    left: 0
    background-color: $color_white

    &::before
        +fit
        content: ''
        opacity: 0
        box-shadow: 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07)
        transition: opacity $easing $duration_fast

    &.sticky
        &::before
            opacity: 1

.g
    .g_restrict
        display: flex
        align-items: center
        justify-content: space-between
        padding-top: $gap
        padding-bottom: $gap

+desktop
    .header
        transition: transform $easing $duration_fast

        .logo,
        .selector
            transition: transform $easing $duration_fast

        &::before
            box-shadow: 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07), 0 8px 16px rgba(0,0,0,0.07), 0 16px 32px rgba(0,0,0,0.07), 0 32px 64px rgba(0,0,0,0.07)

        &.sticky
            transform: translateY(#{$gap * -1.5})

            .logo,
            .selector
                transform: translateY(#{$gap * 0.75})

    .g
        .g_restrict
            padding-top: ($gap * 1.5)
            padding-bottom: ($gap * 1.5)
</style>
